import { Enum_Input_Types } from "src/api/input/enum";
import BasicSelect from "src/inputs/BasicSelect";
import BasicTextField from "src/inputs/BasicTextField";
import CheckboxTextField from "src/inputs/CheckboxTextField";
import RadioTextField from "src/inputs/RadioTextField";
import TextArea from "src/inputs/TextArea";
import { Type_Props_Input } from "src/types/input";

// This component is used to display the input related to the dynamic form
const Input = ({ data }: Type_Props_Input) => {
    const commonTextTypes = [
        Enum_Input_Types.NUMBER,
        Enum_Input_Types.DATE,
        Enum_Input_Types.TEXT,
    ];

    const inputTypes = [
        {
            type: Enum_Input_Types.TEXTAREA,
            component: <TextArea data={data} />,
        },
        ...commonTextTypes.map((type) => ({
            type,
            component: <BasicTextField data={data} />,
        })),
        {
            type: Enum_Input_Types.CHECKBOX,
            component: <CheckboxTextField data={data} />,
        },
        {
            type: Enum_Input_Types.RADIO,
            component: <RadioTextField data={data} />,
        },
        {
            type: Enum_Input_Types.DROPDOWN,
            component: <BasicSelect data={data} />,
        },
    ];

    return (
        <>
            {inputTypes.find((option) => option.type === data?.type)?.component}
        </>
    );
};

export default Input;
